import { Routes } from '@angular/router';
import { aclGuard } from '../acl.guard';
import { authGuard } from '../auth.guard';
import { content } from 'src/environments/data';

export const CONTENT_ROUTES: Routes = [
  {
    path: 'content-list',
    loadComponent: () =>
      import('./content-list/content-list.component').then((m) => m.ContentListComponent),
    canActivate: [authGuard, aclGuard],
    data: { requiredPermission: 'feature.content', meta: content.WEBDDN_META, breadcrumb: 'Content List' },
  },
  {
    path: 'content/new',
    loadComponent: () =>
      import('./content-editor/content-editor.component').then((m) => m.ContentEditorComponent),
    canActivate: [authGuard, aclGuard],
    data: { requiredPermission: 'feature.content.editor', meta: content.WEBDDN_META, breadcrumb: 'New Content' },
  },
  {
    path: 'content/new/:editor',
    loadComponent: () =>
      import('./content-editor/content-editor.component').then((m) => m.ContentEditorComponent),
    canActivate: [authGuard, aclGuard],
    data: { requiredPermission: 'feature.content.editor', meta: content.WEBDDN_META, breadcrumb: 'New Content' },
  },
  {
    path: 'content/edit/:id',
    loadComponent: () =>
      import('./content-editor/content-editor.component').then((m) => m.ContentEditorComponent),
    canActivate: [authGuard, aclGuard],
    data: { requiredPermission: 'feature.content.editor', meta: content.WEBDDN_META, breadcrumb: 'Edit Content' },
  },
  {
    path: 'content/edit/:id/:editor',
    loadComponent: () =>
      import('./content-editor/content-editor.component').then((m) => m.ContentEditorComponent),
    canActivate: [authGuard, aclGuard],
    data: { requiredPermission: 'feature.content.editor', meta: content.WEBDDN_META, breadcrumb: 'Edit Content' },
  },
  {
    path: 'content/view/:id',
    loadComponent: () =>
      import('./content-view/content-view.component').then((m) => m.ContentViewComponent),
    canActivate: [authGuard, aclGuard],
    data: { requiredPermission: 'feature.content', meta: content.WEBDDN_META, breadcrumb: 'View Content' },
  },
];
